import React from 'react'
import { FaLinkedinIn, FaReact, FaNodeJs, FaJs, FaAws } from "react-icons/fa";
import { SiMongodb, SiExpress, SiGithub, SiGmail, SiTypescript, SiRedux, SiNextdotjs, SiAwsorganizations } from "react-icons/si";
const Media = () => {
  return (
    <div className="flex flex-col xl:flex-row gap-6 lgl:gap-0 justify-between">
      <div>
        <h2 className="text-base uppercase font-titleFont mb-4">
          Find me on
        </h2>
        <div className="flex gap-4">
          <a href="https://github.com/VikasX" target="_blank" rel="noopener noreferrer">

            <span className="bannerIcon">
              <SiGithub />
            </span>
          </a>
          {/* <span className="bannerIcon">
            <a href="mailto:mishra7vikas@gmail.com">
              <SiGmail /></a>
            </span> */}
          <a href="https://www.linkedin.com/in/vikasmishra07" target="_blank" rel="noopener noreferrer">

            <span className="bannerIcon">
              <FaLinkedinIn />
            </span>
          </a>
        </div>
      </div>
      <div>
        <h2 className="text-base uppercase font-titleFont mb-4">
          WEB STACK
        </h2>
        <div className="flex gap-4">
          <span className="bannerIcon">
            <FaJs />
          </span>
          <span className="bannerIcon">
            <SiTypescript />

          </span>
          <span className="bannerIcon">
            <FaReact />
          </span>
          {/* <span className="bannerIcon">
              <SiRedux />
            </span> */}
          <span className="bannerIcon">
            <SiNextdotjs />
          </span>
          <span className="bannerIcon">
            <FaAws />
          </span>
        </div>
      </div>
    </div>
  )
}

export default Media